import { Icon, IconButton } from "@chakra-ui/react";
import { t } from "i18next";
import { FaTrash } from "react-icons/fa";
import { useSub } from "../../../common/subscription/useSub";

export const DeleteSettingButton = ({ isLoading, onClick }: { isLoading: boolean; onClick: () => void }) => {
  const { canUpdateOrganization } = useSub();
  if (!canUpdateOrganization) return null;
  return (
    <IconButton
      aria-label={t("Delete setting")}
      icon={<Icon as={FaTrash} />}
      size={"xs"}
      isLoading={isLoading}
      onClick={onClick}
    />
  );
};
